<template>
  <v-footer padless class="mt-auto">
    <v-col class="text-center" cols="12">
      <v-row align="center" justify="center">
        <v-col cols="12" lg="2" xl="2" class="d-flex justify-center">
          <a href="https://aniq.org.mx/webpublico/" target="_blank">
            <v-img src="@/assets/ANIQ.jpg" height="110" width="110" contain></v-img>
          </a>
        </v-col>
        <v-col cols="12" lg="2" xl="2" class="d-flex justify-center">
          <a href="https://www.cinvestav.mx/" target="_blank">
            <v-img src="@/assets/CINVESTAV.jpg" height="110" width="110" contain></v-img>
          </a>
        </v-col>
        <v-col cols="12" lg="2" xl="2" class="d-flex justify-center">
          <a href="https://aniq.org.mx/webpublico/cipres.asp" target="_blank">
            <v-img src="@/assets/Cipres.jpg" height="110" width="110" contain></v-img>
          </a>
        </v-col>
      </v-row>

      <v-card-text class="mt-5">
        <!-- ENLACE PARA FACEBOOK -->
        <a href="https://www.facebook.com/OQCdMx/" target="_blank">
          <v-icon class="mx-4">mdi-facebook</v-icon> https://www.facebook.com/OQCdMx/
        </a>

        <!-- ENLACE PARA GMAIL -->
        <a href="mailto:olimpiada.quimica.cdmx@quimica.unam.mx">
          <v-icon class="mx-4">mdi-gmail</v-icon> olimpiada.quimica.cdmx@quimica.unam.mx
        </a>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-text class="body-2">
        <strong>Todos los derechos reservados {{ new Date().getFullYear() }} — Facultad de Química, UNAM.</strong>
        Esta página puede ser reproducida con fines no lucrativos, siempre y cuando no se mutile, se cite la fuente
        completa y su dirección electrónica.
        Contiene enlaces con diversos portales de entidades y organizaciones académicas, estudiantiles y profesionales,
        así como con páginas personales cuyos contenidos son de la responsabilidad
        exclusiva de sus titulares. <a href="https://quimica.unam.mx/aviso-de-privacidad/">Aviso de privacidad</a>
      </v-card-text>
    </v-col>
  </v-footer>
</template>


<script>
export default {
  data: () => ({}),
}
</script>